import Vue from "vue";
import Vuex from "vuex";
import firebase from "firebase/app";
import "firebase/auth";
import "firebase/database";
import axios from "axios";
import router from "./router";

Vue.use(Vuex);

const projectId = process.env.VUE_APP_PROJECT_ID;

const SET_NEW_USER_DATA = "SET_NEW_USER_DATA";
const SET_DISABLE_ALL = "SET_DISABLE_ALL";
const FETCH_USERS = "FETCH_USERS";
const CHANGE_AUTH = "CHANGE_AUTH";
const USER_DATA = "USER_DATA";
const IS_LOGGED_IN = "IS_LOGGED_IN";
const SHOW_LOADING = "SHOW_LOADING";
const LOGIN_DATA = "LOGIN_DATA";
const INIT_VALUES = "INIT_VALUES";
const READ_ONLY_CALENDAR = "READ_ONLY_CALENDAR";
const EVENTS_FROM_DB = "EVENTS_FROM_DB";
const SET_LOADING = "SET_LOADING";
// const SET_MESSAGE = "SET_MESSAGE";
const SET_GENERAL_MESSAGE = "SET_GENERAL_MESSAGE";
const SET_LOADED_ODS = "SET_LOADED_ODS";
const SET_REVISION = "SET_REVISION";
const SET_APPROVED = "SET_APPROVED";
const SET_CURRENT_UID = "SET_CURRENT_UID";
const SET_COMMENTS = "SET_COMMENTS";
const SET_COMMENTS_LEADER = "SET_COMMENTS_LEADER";
const SET_CURRENT_SERVICE_TICKETS = "SET_CURRENT_SERVICE_TICKETS";
const SET_DIALOG_CHANGE_PASSWORD = "SET_DIALOG_CHANGE_PASSWORD";
const SET_GENERAL_MESSAGE_SHOW_SB = "SET_GENERAL_MESSAGE_SHOW_SB";
const SET_GENERAL_MESSAGE_INFO_SB = "SET_GENERAL_MESSAGE_INFO_SB";
const SET_USER_TO_CHANGE_PASSWORD = "SET_USER_TO_CHANGE_PASSWORD";
const CHANGE_CURRENT_MONTH = "CHANGE_CURRENT_MONTH";
const CHANGE_CURRENT_MONTH_LF = "CHANGE_CURRENT_MONTH_LF";
const SET_CURRENT_DATE = "SET_CURRENT_DATE";
const SET_START_END_CALENDAR = "SET_START_END_CALENDAR";
const SET_HOLY_DAYS = "SET_HOLY_DAYS";
const SET_LOADED_ODS_CURRENT_REAL_MONTH = "SET_LOADED_ODS_CURRENT_REAL_MONTH";
const CHANGE_CURRENT_REAL_YEAR = "CHANGE_CURRENT_REAL_YEAR";
const CHANGE_CURRENT_REAL_MONTH = "CHANGE_CURRENT_REAL_MONTH";
const CHANGE_CURRENT_REAL_MONTH_LF = "CHANGE_CURRENT_REAL_MONTH_LF";
const SET_ACTIVE_VALUE = "SET_ACTIVE_VALUE";
const SET_RESTRICTION_DATES = "SET_RESTRICTION_DATES";

import { weekDaysMap, monthsBaseInfo } from "./utils/datesInfo";
import { holyDaysCO } from "./utils/holyDaysCO";

// const currentRealMonthNumber = 3;
// const currentRealMonth = monthsBaseInfo.get(currentRealMonthNumber).name;
// const currentSTMonthNumber = currentRealMonthNumber - 1;
// const currentSTMonth = monthsBaseInfo.get(currentSTMonthNumber).name;

const appMode = process.env.VUE_APP_MODE;
const appVersion = process.env.VUE_APP_VERSION;

// import allUsersJSON from "./utils/allUsers.json";
// const allUsers = allUsersJSON;

// console.log("ALL USERS JSON: ", allUsersJSON);
// console.log("ALL USERS: ", allUsers);
// XXXX const allUsers = JSON.parse(allUsersJSON);

// import testerUsersJSON from "./utils/testerUsers.json";
// const testerUsers = testerUsersJSON;

function formatDateSCAction(date) {
  const dateSplit = date.split("/");
  const dayDate = dateSplit[0];
  const monttDate = dateSplit[1];
  const yearDate = dateSplit[2];
  const dateFormated = `${yearDate}-${monttDate}-${dayDate}`;
  return dateFormated;
}

export default new Vuex.Store({
  state: {
    currentMonthNumberST: 0,
    amountOfRestrictionDaysEDM: 0,
    amountOfRestrictionDaysST: 0,
    restrictionDatesEvents: [],
    endDateEvent: [],
    startDateEvent: [],
    currentSTMonth: "",
    loadedODSCurrentRealMonth: [],
    yearFooter: "",
    startCalendar: "",
    endCalendar: "",
    versionApp: `v${appVersion}:${appMode}`,
    currentNumberOfDays: null,
    numberOfDaysST: null,
    currentRealMonth: "",
    currentRealMonthNumber: null,
    userToChangePassword: null,
    generalMessageInfoSB: {
      type: "success",
      message: ""
    },
    generalMessageSB: false,
    changePassDialog: false,
    dateSince: "",
    dateUntil: "",
    amountOfWork: 0,
    currentServiceTickets: [],
    currentMonth: "",
    currentMonthNumber: null,
    currentYear: "",
    holyDays: [],
    realMonthTotalDays: null,
    userDataCRUD: {
      email: "",
      firstName: "",
      lastName: "",
      role: 0,
      ods: null
    },
    emailCRUD: "",
    commentsLeader: "",
    messagesComments: "",
    comments: "",
    showTextArea: false,
    currentUID: "",
    approved: 0,
    loadedODS: [],
    messageTitle: "",
    messageInfo: "",
    actionMessage: "",
    dataAction: null,
    showMessage: false,
    showCancelBtn: false,
    showSendBtn: false,
    showOkBtn: false,
    // message: "",
    loading: false,
    eventsFromDB: [],
    readOnlyCalendar: false,
    showLoading: false,
    isLoggedIn: false,
    authorized: false,
    user: "",
    password: "",
    users: [],
    disableAll: false,
    userData: {
      email: "",
      firstName: "",
      lastName: "",
      id: "",
      role: null,
      ods: null,
      emailLF: "",
      emailAODS: "",
      startDate: "",
      endDate: ""
    },
    userProfile: {}
  },
  getters: {
    currentMonthNumberST: state => state.currentMonthNumberST,
    numberOfDaysST: state => state.numberOfDaysST,
    amountOfWork: state => state.amountOfWork,
    amountOfRestrictionDaysEDM: state => state.amountOfRestrictionDaysEDM,
    amountOfRestrictionDaysST: state => state.amountOfRestrictionDaysST,
    restrictionDatesEvents: state => state.restrictionDatesEvents,
    endDateEvent: state => state.endDateEvent,
    startDateEvent: state => state.startDateEvent,
    currentSTMonth: state => state.currentSTMonth,
    loadedODSCurrentRealMonth: state => state.loadedODSCurrentRealMonth,
    yearFooter: state => state.yearFooter,
    startCalendar: state => state.startCalendar,
    endCalendar: state => state.endCalendar,
    currentRealMonth: state => state.currentRealMonth,
    currentRealMonthNumber: state => state.currentRealMonthNumber,
    endDate: state => {
      if (state.userData.endDate) return state.userData.endDate;
      else return null;
    },
    currentYear: state => state.currentYear,
    userToChangePassword: state => state.userToChangePassword,
    generalMessageInfoSB: state => state.generalMessageInfoSB,
    generalMessageSB: state => state.generalMessageSB,
    changePassDialog: state => state.changePassDialog,
    currentServiceTickets: state => state.currentServiceTickets,
    currentMonthNumber: state => state.currentMonthNumber,
    currentMonth: state => state.currentMonth,
    versionApp: state => state.versionApp,
    holyDays: state => state.holyDays,
    realMonthTotalDays: state => state.realMonthTotalDays,
    currentUID: state => state.currentUID,
    emailCRUD: state => state.userDataCRUD.email,
    firstNameCRUD: state => state.userDataCRUD.firstName,
    lastNameCRUD: state => state.userDataCRUD.lastName,
    roleCRUD: state => state.userDataCRUD.role,
    odsCRUD: state => state.userDataCRUD.ods,
    commentsLeader: state => state.commentsLeader,
    messagesComments: state => state.messagesComments,
    showTextArea: state => state.showTextArea,
    showCancelBtn: state => state.showCancelBtn,
    showSendBtn: state => state.showSendBtn,
    showOkBtn: state => state.showOkBtn,
    approved: state => state.approved,
    loadedODS: state => state.loadedODS,
    messageTitle: state => state.messageTitle,
    messageInfo: state => state.messageInfo,
    actionMessage: state => state.actionMessage,
    dataAction: state => state.dataAction,
    showMessage: state => state.showMessage,
    // message: state => state.message,
    loading: state => state.loading,
    eventsFromDB: state => state.eventsFromDB,
    readOnlyCalendar: state => state.readOnlyCalendar,
    isLoggedIn: state => state.isLoggedIn,
    users: state => state.users,
    disableAll: state => state.disableAll,
    email: state => state.userData.email,
    firstName: state => state.userData.firstName,
    lastName: state => state.userData.lastName,
    rol: state => state.userData.rol,
    role: state => state.userData.role,
    ods: state => state.userData.ods,
    emailLF: state => state.userData.emailLF,
    emailAODS: state => state.userData.emailAODS,
    startDate: state => state.userData.startDate
  },
  mutations: {
    [SET_RESTRICTION_DATES](state, data) {
      const monthTempST = Number(data.currentMonth) - 1;
      const monthST = monthTempST === 0 ? 12 : monthTempST;
      const yearST =
        monthTempST === 0
          ? String(Number(data.currentYear) - 1)
          : data.currentYear;

      // ------- START DATE EVENT
      const startDateEventFormated = formatDateSCAction(
        state.userData.startDate
      );
      state.startDateEvent = [
        { date: startDateEventFormated, ods: "startDate" }
      ];

      const startDateSplit = state.userData.startDate.split("/");
      const startDateDay = startDateSplit[0];
      const startDateMonth = startDateSplit[1];
      const startDateYear = startDateSplit[2];

      if (Number(startDateMonth) === monthST && startDateYear === yearST)
        state.amountOfRestrictionDaysST = Number(startDateDay - 1);

      for (let index = 1; index < Number(startDateDay); index++) {
        const dayTo = index < 10 ? `0${String(index)}` : String(index);
        const fullDateTo = `${startDateYear}-${startDateMonth}-${dayTo}`;
        const fullDate = new Date(`${fullDateTo}, 00:00:00`);
        const weekday = fullDate.getDay();
        state.restrictionDatesEvents.push({
          date: fullDateTo,
          ods: "NA",
          odsN: "NA",
          nameDay: weekDaysMap.get(weekday)
        });
      }
      // ---------- END DATE
      if (state.userData.endDate !== "") {
        // ------- END DATE EVENT
        const endDateEventFormated = formatDateSCAction(state.userData.endDate);
        state.endDateEvent = [{ date: endDateEventFormated, ods: "endDate" }];

        const endDateSplit = state.userData.endDate.split("/");
        const endDateDay = endDateSplit[0];
        const endDateMonth = endDateSplit[1];
        const endDateYear = endDateSplit[2];

        const endDateDayIndex = Number(endDateDay) + 1;

        let limitLoop;
        const monthTempCurrent = Number(data.currentMonth);
        if (
          Number(endDateMonth) === monthTempCurrent &&
          endDateYear === data.currentYear
        ) {
          // End date month same with the current real month
          state.amountOfRestrictionDaysEDM =
            data.currentNumberOfDays - Number(endDateDay);
          limitLoop = data.currentNumberOfDays;
        } else if (Number(endDateMonth) === monthST && endDateYear === yearST) {
          // End date month same with the service ticket month
          const amountEndDays = data.numberOfDaysST - Number(endDateDay);
          state.amountOfRestrictionDaysST =
            state.amountOfRestrictionDaysST + amountEndDays;
          limitLoop = data.numberOfDaysST;
        }

        // console.log("LIMIT LOOP:", limitLoop);

        for (let index = endDateDayIndex; index <= limitLoop; index++) {
          const dayTo = index < 10 ? `0${String(index)}` : String(index);
          const fullDateTo = `${endDateYear}-${endDateMonth}-${dayTo}`;
          const fullDate = new Date(`${fullDateTo}, 00:00:00`);
          const weekday = fullDate.getDay();
          state.restrictionDatesEvents.push({
            date: fullDateTo,
            ods: "NA",
            odsN: "NA",
            nameDay: weekDaysMap.get(weekday)
          });
        }
      }
    },
    [SET_ACTIVE_VALUE](state, payload) {
      const userIndex = state.users.findIndex(item => item.uid === payload.uid);
      if (userIndex !== -1) state.users[userIndex].active = payload.value;
    },
    [CHANGE_CURRENT_REAL_YEAR](state) {
      const yearTemp =
        state.currentRealMonthNumber === 1
          ? String(Number(state.currentYear) - 1)
          : state.currentYear;
      state.currentYear = yearTemp;
    },
    [CHANGE_CURRENT_REAL_MONTH](state) {
      // const yearTemp =
      //   state.currentRealMonthNumber === 1
      //     ? String(Number(state.currentYear) - 1)
      //     : state.currentYear;
      // state.currentYear = yearTemp;

      if (state.currentMonthNumber === state.currentRealMonthNumber) {
        const monthCheck =
          state.currentRealMonthNumber - 1 === 0
            ? 12
            : state.currentRealMonthNumber - 1;
        state.currentMonthNumber = monthCheck;
      }

      state.currentMonth = monthsBaseInfo.get(state.currentMonthNumber).name;

      const monthTemp =
        state.currentMonthNumber < 10
          ? `0${String(state.currentMonthNumber)}`
          : String(state.currentMonthNumber);

      state.dateSince = `01/${monthTemp}/${state.currentYear}`;
      state.dateUntil = `${String(state.numberOfDaysST)}/${monthTemp}/${
        state.currentYear
      }`;

      state.amountOfWork =
        state.numberOfDaysST - state.amountOfRestrictionDaysST;
      state.realMonthTotalDays = state.numberOfDaysST;
    },
    [CHANGE_CURRENT_REAL_MONTH_LF](state) {
      const yearTemp =
        state.currentRealMonthNumber === 1 &&
        state.currentYear === state.yearFooter
          ? String(Number(state.currentYear) - 1)
          : state.currentYear;
      state.currentYear = yearTemp;

      if (state.currentMonthNumber === state.currentRealMonthNumber) {
        const monthCheck =
          state.currentRealMonthNumber - 1 === 0
            ? 12
            : state.currentRealMonthNumber - 1;
        state.currentMonthNumber = monthCheck;
      }

      state.currentMonth = monthsBaseInfo.get(state.currentMonthNumber).name;

      const monthTemp =
        state.currentMonthNumber < 10
          ? `0${String(state.currentMonthNumber)}`
          : String(state.currentMonthNumber);

      state.dateSince = `01/${monthTemp}/${state.currentYear}`;
      state.dateUntil = `${String(state.numberOfDaysST)}/${monthTemp}/${
        state.currentYear
      }`;

      state.amountOfWork =
        state.numberOfDaysST - state.amountOfRestrictionDaysST;
      state.realMonthTotalDays = state.numberOfDaysST;
    },
    [SET_LOADED_ODS_CURRENT_REAL_MONTH](state, data) {
      state.loadedODSCurrentRealMonth = data;
    },
    [SET_HOLY_DAYS](state) {
      const holyDaysCurrentYear = holyDaysCO.get(Number(state.currentYear));
      state.holyDays = holyDaysCurrentYear.get(state.currentMonthNumber);
    },
    [SET_START_END_CALENDAR](state) {
      const monthTemp =
        state.currentMonthNumber < 10
          ? `0${String(state.currentMonthNumber)}`
          : String(state.currentMonthNumber);
      state.startCalendar = `${state.currentYear}-${monthTemp}-01`;
      state.endCalendar = `${state.currentYear}-${monthTemp}-${String(
        state.realMonthTotalDays
      )}`;
    },
    [SET_CURRENT_DATE](state, data) {
      state.yearFooter = data.currentYear;
      state.currentRealMonthNumber = Number(data.currentMonth);

      // TO TEST
      // state.currentRealMonthNumber = 1;

      const yearTemp =
        state.currentRealMonthNumber === 1
          ? String(Number(data.currentYear) - 1)
          : data.currentYear;
      state.currentYear = yearTemp;

      state.currentRealMonth = monthsBaseInfo.get(
        state.currentRealMonthNumber
      ).name;

      const monthCheck =
        state.currentRealMonthNumber - 1 === 0
          ? 12
          : state.currentRealMonthNumber - 1;
      state.currentMonthNumber = monthCheck;
      state.currentMonthNumberST = monthCheck;
      state.currentMonth = monthsBaseInfo.get(state.currentMonthNumber).name;

      state.currentSTMonth = monthsBaseInfo.get(state.currentMonthNumber).name;

      const monthTemp =
        state.currentMonthNumber < 10
          ? `0${String(state.currentMonthNumber)}`
          : String(state.currentMonthNumber);

      state.currentNumberOfDays = data.currentNumberOfDays;
      state.numberOfDaysST = data.numberOfDaysST;

      state.dateSince = `01/${monthTemp}/${state.currentYear}`;
      state.dateUntil = `${String(state.numberOfDaysST)}/${monthTemp}/${
        state.currentYear
      }`;

      state.amountOfWork =
        state.numberOfDaysST - state.amountOfRestrictionDaysST;
      state.realMonthTotalDays = state.numberOfDaysST;
    },
    [CHANGE_CURRENT_MONTH](state) {
      const yearTemp =
        state.currentRealMonthNumber === 1
          ? String(Number(state.currentYear) + 1)
          : state.currentYear;
      state.currentYear = yearTemp;

      if (state.currentMonthNumber !== state.currentRealMonthNumber) {
        state.currentMonthNumber = state.currentRealMonthNumber;
      }
      // else {
      //   state.currentMonthNumber = state.currentRealMonthNumber - 1;
      // }
      state.currentMonth = monthsBaseInfo.get(state.currentMonthNumber).name;

      const monthTemp =
        state.currentMonthNumber < 10
          ? `0${String(state.currentMonthNumber)}`
          : String(state.currentMonthNumber);

      state.dateSince = `01/${monthTemp}/${state.currentYear}`;
      state.dateUntil = `${String(state.currentNumberOfDays)}/${monthTemp}/${
        state.currentYear
      }`;

      state.amountOfWork =
        state.currentNumberOfDays - state.amountOfRestrictionDaysEDM;
      state.realMonthTotalDays = state.currentNumberOfDays;
    },
    [CHANGE_CURRENT_MONTH_LF](state) {
      const yearTemp =
        state.currentRealMonthNumber === 1
          ? state.yearFooter
          : state.currentYear;
      state.currentYear = yearTemp;

      if (state.currentMonthNumber !== state.currentRealMonthNumber) {
        state.currentMonthNumber = state.currentRealMonthNumber;
      }
      // else {
      //   state.currentMonthNumber = state.currentRealMonthNumber - 1;
      // }
      state.currentMonth = monthsBaseInfo.get(state.currentMonthNumber).name;

      const monthTemp =
        state.currentMonthNumber < 10
          ? `0${String(state.currentMonthNumber)}`
          : String(state.currentMonthNumber);

      state.dateSince = `01/${monthTemp}/${state.currentYear}`;
      state.dateUntil = `${String(state.currentNumberOfDays)}/${monthTemp}/${
        state.currentYear
      }`;

      state.amountOfWork =
        state.currentNumberOfDays - state.amountOfRestrictionDaysEDM;
      state.realMonthTotalDays = state.currentNumberOfDays;
    },
    [SET_USER_TO_CHANGE_PASSWORD](state, user) {
      state.userToChangePassword = user;
    },
    [SET_GENERAL_MESSAGE_INFO_SB](state, data) {
      state.generalMessageInfoSB = data;
    },
    [SET_GENERAL_MESSAGE_SHOW_SB](state, value) {
      state.generalMessageSB = value;
    },
    [SET_DIALOG_CHANGE_PASSWORD](state, value) {
      state.changePassDialog = value;
    },
    [SET_CURRENT_SERVICE_TICKETS](state, data) {
      state.currentServiceTickets = data;
    },
    [SET_COMMENTS_LEADER](state, data) {
      state.commentsLeader = data;
    },
    [SET_COMMENTS](state, data) {
      state.comments = data;
    },
    [SET_CURRENT_UID](state, value) {
      state.currentUID = value;
    },
    [SET_APPROVED](state, value) {
      state.approved = value;
    },
    [SET_REVISION](state, data) {
      let key = "loadedODS";
      if (state.currentMonthNumber === state.currentRealMonthNumber)
        key = "loadedODSCurrentRealMonth";

      const index = state[key].findIndex(item => item.uid === data.uid);
      if (index !== -1) state[key][index].approved = data.approved;
    },
    [SET_LOADED_ODS](state, data) {
      state.loadedODS = data;
    },
    [SET_GENERAL_MESSAGE](state, payload) {
      state.showMessage = payload.showMessage;
      state.showTextArea = payload.hasOwnProperty("showTextArea")
        ? payload.showTextArea
        : false;
      state.showCancelBtn = payload.showCancelBtn;
      state.showSendBtn = payload.showSendBtn;
      state.showOkBtn = payload.showOkBtn;
      state.actionMessage = payload.action;
      state.dataAction = payload.data;
      state.messageTitle = payload.messageTitle;
      state.messageInfo = payload.messageInfo;
      state.messagesComments = payload.hasOwnProperty("showTextArea")
        ? payload.messagesComments
        : "";
    },
    // [SET_MESSAGE](state, value) {
    //   state.message = value;
    // },
    [SET_LOADING](state, value) {
      state.loading = value;
    },
    [EVENTS_FROM_DB](state, data) {
      state.eventsFromDB = data;
    },
    [READ_ONLY_CALENDAR](state, value) {
      state.readOnlyCalendar = value;
    },
    [INIT_VALUES](state) {
      state.userData = {
        email: "",
        firstName: "",
        lastName: "",
        id: "",
        role: null,
        ods: null,
        emailLF: "",
        emailAODS: "",
        startDate: "",
        endDate: ""
      };
      state.restrictionDatesEvents = [];
      state.startDateEvent = [];
      state.endDateEvent = [];
    },
    [LOGIN_DATA](state, data) {
      state.user = data.user;
      state.password = data.password;
    },
    [SHOW_LOADING](state, value) {
      state.showLoading = value;
    },
    [IS_LOGGED_IN](state, value) {
      state.isLoggedIn = value;
    },
    [USER_DATA](state, data) {
      state.userData.email = data.email;
      state.userData.userUID = data.uid;
      state.userData.firstName = data.firstName;
      state.userData.lastName = data.lastName;
      state.userData.role = data.role;
      state.userData.ods = data.ods;
      state.userData.emailLF = data.emailLF;
      state.userData.emailAODS = data.emailAODS;
      state.userData.startDate = data.startDate;
      if (data.endDate) state.userData.endDate = data.endDate;
    },
    [CHANGE_AUTH](state, data) {
      state.authorized = data;
      state.user = "";
      state.password = "";
    },
    [FETCH_USERS](state, payload) {
      state.users = payload;
    },
    [SET_DISABLE_ALL](state, value) {
      state.disableAll = value;
    },
    [SET_NEW_USER_DATA](state, data) {
      state.userDataCRUD[data.key] = data.value;
    }
  },
  actions: {
    deactivateUser({ commit }, user) {
      commit(SET_LOADING, true);
      firebase
        .database()
        .ref(`users/${user.uid}`)
        .update({ active: 0 })
        .then(() => {
          console.log("USER active UPDATED OK");
          commit(SET_LOADING, false);
          const payload = {
            showMessage: true,
            showCancelBtn: false,
            showSendBtn: false,
            showOkBtn: true,
            action: "",
            data: null,
            messageTitle: "Usuario Desactivado",
            messageInfo: `Se ha desactivado el usuario ${
              user.fullName
            } correctamente.`
          };
          const userDataUpdate = {
            value: 0,
            uid: user.uid
          };
          commit(SET_ACTIVE_VALUE, userDataUpdate);
          commit(SET_GENERAL_MESSAGE, payload);
        })
        .catch(error => {
          console.log("ERROR DU", error);
        });
    },
    setCurrentDate({ state, commit, dispatch }, data) {
      // console.log("setCurrentDate", data);
      commit(SET_LOADING, true);
      if (state.userData.role < 2) commit(SET_RESTRICTION_DATES, data);
      commit(SET_CURRENT_DATE, data);
      commit(SET_START_END_CALENDAR);
      commit(SET_HOLY_DAYS);
      dispatch("fetchEvents");
      commit(SET_LOADING, false);
    },
    addEndDate({ commit }, data) {
      commit(SET_LOADING, true);
      console.log("ADD END DATE", data);
      return firebase
        .database()
        .ref(`users/${data.uid}`)
        .update({ endDate: data.endDate })
        .then(() => {
          // console.log("ADD END DATE", response);
          commit(SET_LOADING, false);
          commit(SET_COMMENTS, "");
          const payload = {
            showMessage: true,
            showCancelBtn: false,
            showSendBtn: false,
            showOkBtn: true,
            action: "",
            data: null,
            messageTitle: "Información Enviada",
            messageInfo: "Se ha agregado la Fecha de Finalización"
          };
          commit(SET_GENERAL_MESSAGE, payload);
        })
        .catch(error => {
          commit(SET_LOADING, false);
          console.log("AED ERROR", error);
        });
    },
    changeUserPasswordAdmin({ commit, state }, data) {
      commit(SET_LOADING, true);
      const userData = { ...data, ...state.userToChangePassword };
      console.log("changeUserPasswordAdmin USER DATA: ", userData);
      axios
        .post(
          `https://us-central1-${projectId}.cloudfunctions.net/changePasswordFromAdmin`,
          {
            userData: userData
          }
        )
        .then(response => {
          // console.log("RESPONSE! -> ", response);
          // console.log("SUCCESS? -> ", response.data.success);
          if (response.data.success) {
            console.log("USER PASSWORD CHANGED!");
            const message = `Clave actualizada correctamente para ${
              userData.email
            }!`;
            const payload = {
              type: "success",
              message
            };
            commit(SET_GENERAL_MESSAGE_INFO_SB, payload);
            commit(SET_GENERAL_MESSAGE_SHOW_SB, true);
          } else {
            console.log("USER PASSWORD NOT CHANGED!");
            let message = `Se presentó un Error que no permitió actualizar la clave para para ${
              userData.email
            }; por favor intertar nuevamente.`;

            const payload = {
              type: "error",
              message
            };
            commit(SET_GENERAL_MESSAGE_INFO_SB, payload);
            commit(SET_GENERAL_MESSAGE_SHOW_SB, true);
          }
          commit(SET_USER_TO_CHANGE_PASSWORD, null);
          commit(SET_DIALOG_CHANGE_PASSWORD, false);
          commit(SET_LOADING, false);
        })
        .catch(error => {
          console.log("ERROR! -> ", error);
          let message =
            "Se presentó un Error inesperado, por favor intertar nuevamente.";
          // if (error.code === "auth/weak-password")
          //   message = "ERROR! La clave de tener como mínimo 6 caracteres.";
          // else if (error.code === "auth/requires-recent-login") {
          //   message =
          //     "ERROR! Debe iniciar una nueva sesión para poder realizar cambio de clave.";
          //   dispatch("logout");
          // }
          const payload = {
            type: "error",
            message
          };
          commit(SET_GENERAL_MESSAGE_INFO_SB, payload);
          commit(SET_GENERAL_MESSAGE_SHOW_SB, true);
          commit(SET_USER_TO_CHANGE_PASSWORD, null);
          commit(SET_DIALOG_CHANGE_PASSWORD, false);
          commit(SET_LOADING, false);
        });
    },
    updatePassword({ commit, dispatch }, data) {
      commit(SET_LOADING, true);
      const user = firebase.auth().currentUser;

      user
        .updatePassword(data.pass1)
        .then(() => {
          const message = "Clave actualizada correctamente!";
          const payload = {
            type: "success",
            message
          };
          commit(SET_GENERAL_MESSAGE_INFO_SB, payload);
          commit(SET_GENERAL_MESSAGE_SHOW_SB, true);
          commit(SET_LOADING, false);
          commit(SET_DIALOG_CHANGE_PASSWORD, false);
        })
        .catch(error => {
          console.log("ERROR UP: ", error);
          let message =
            "Se presentó un Error inesperado, por favor intertar nuevamente.";
          if (error.code === "auth/weak-password")
            message = "ERROR! La clave de tener como mínimo 6 caracteres.";
          else if (error.code === "auth/requires-recent-login") {
            message =
              "ERROR! Debe iniciar una nueva sesión para poder realizar cambio de clave.";
            dispatch("logout");
          }

          const payload = {
            type: "error",
            message
          };
          commit(SET_GENERAL_MESSAGE_INFO_SB, payload);
          commit(SET_GENERAL_MESSAGE_SHOW_SB, true);
          commit(SET_LOADING, false);
          commit(SET_DIALOG_CHANGE_PASSWORD, false);
        });
    },
    changePass({ commit }, value) {
      commit(SET_DIALOG_CHANGE_PASSWORD, value);
    },
    consecutiveCalc({ getters, state }) {
      // console.log("getters.currentMonthNumber", getters.currentMonthNumber);
      // console.log("state.currentYear", state.currentYear, Number(state.currentYear));
      let consecutive;
      const [
        // eslint-disable-next-line no-unused-vars
        startDateDay,
        startDateMonth,
        startDateYear
      ] = getters.startDate.split("/");
      // console.log(startDateDay, startDateMonth, startDateYear);

      if (Number(state.currentYear) - Number(startDateYear) > 0) {
        // console.log("not current year");
        const amountPastYear = 12 - Number(startDateMonth);
        // console.log("amountPastYear", amountPastYear);
        consecutive = getters.currentMonthNumber + amountPastYear;
      } else {
        // console.log("current year");
        consecutive = getters.currentMonthNumber - Number(startDateMonth);
      }
      // console.log(consecutive + 1);
      return consecutive + 1;
    },
    resetPassword({ commit }, emailAddress) {
      // console.log("RESET PASSWORD: ", emailAddress);
      commit(SET_LOADING, true);
      firebase
        .auth()
        .sendPasswordResetEmail(emailAddress)
        .then(() => {
          // console.log("EMAIL SENT: ");
          commit(SET_LOADING, false);
          const message = `Un email fue enviado a ${emailAddress} para que pueda proceder con el restablecimiento de la contraseña.`;
          const payload = {
            showMessage: true,
            showCancelBtn: false,
            showSendBtn: false,
            showOkBtn: true,
            action: "",
            data: null,
            messageTitle: "Email Enviado!",
            messageInfo: message
          };
          commit(SET_GENERAL_MESSAGE, payload);
        })
        .catch(error => {
          // console.log("ERROR RSTP: ", error);
          commit(SET_LOADING, false);
          const errorCode = error.code;
          // console.log("ERROR CODE", errorCode);
          let message =
            "No se ha podido restablecer la contraseña. Por favor intentar de nuevo.";
          if (errorCode === "auth/user-not-found")
            message =
              "Los datos enviados no son validos para Restablecer Contraseña";
          const payload = {
            showMessage: true,
            showCancelBtn: false,
            showSendBtn: false,
            showOkBtn: true,
            action: "",
            data: null,
            messageTitle: "ERROR",
            messageInfo: message
          };
          commit(SET_GENERAL_MESSAGE, payload);
          // const errorMessage = error.message;
          // console.log("ERROR MESSAGE", errorMessage);
        });
    },
    adminData({ commit }, data) {
      // console.log("DATA: ", data.uid);
      commit(SET_LOADING, true);
      return firebase
        .database()
        .ref("admins/" + data.uid)
        .once("value")
        .then(
          function(snapshot) {
            const obj = snapshot.val();
            // console.log("THEN DATA ADMIN DATA", obj.ods);
            const role = "SuperAdmin";
            const infoUser = {
              email: data.email,
              uid: data.uid,
              firstName: obj.firstName,
              lastName: obj.lastName,
              role
            };
            router.push("/admin");
            commit(USER_DATA, infoUser);
            commit(SET_LOADING, false);
          },
          function(errorObject) {
            console.log(errorObject);
          }
        );
    },
    fetchCurrentServiceTickets({ commit, state }) {
      firebase
        .database()
        .ref("ods")
        .orderByChild("month")
        .equalTo(state.currentMonth)
        .on("value", function(snapshot) {
          const obj = snapshot.val();
          const serviceTickets = [];
          for (const key in obj) {
            const tempA = obj[key];
            tempA.key = key;
            serviceTickets.push(tempA);
          }
          // console.log("SERVICE TICKETS: ", serviceTickets);
          commit(SET_CURRENT_SERVICE_TICKETS, serviceTickets);
        });
    },
    // createUserAltA({ commit }, role) {
    //   let usersData;
    //   if (role === 4) usersData = testerUsers;
    //   else usersData = allUsers.filter(item => item.role === role);

    //   // console.log("USER DATA: ", usersData);
    //   axios
    //     .post(
    //       `https://us-central1-${projectId}.cloudfunctions.net/newUserAPIAlt`,
    //       {
    //         usersData
    //       }
    //     )
    //     .then(response => {
    //       console.log("RESPONSE! -> ", response);
    //       // console.log("SUCCESS? -> ", response.data.success);
    //       if (response.data.success) {
    //         console.log("USER CREATED!");
    //       } else {
    //         console.log("USER NOT CREATED!");
    //       }
    //       commit(SET_DISABLE_ALL, false);
    //     })
    //     .catch(error => {
    //       console.log("ERROR! -> ", error);
    //       commit(SET_DISABLE_ALL, false);
    //     });
    // },
    processEvents({ getters }, events) {
      const role = getters.role;
      // console.log("PROCESS EVENT: ", role, events.length);
      const eventsProcessed = [];
      const eventsFinalProcess = [];
      const eventsNA = [];
      /** For Loop that allows go over the events and ingnore holy day event  */
      for (let index = 0; index < events.length; index++) {
        const element = events[index];
        const tempODS =
          element.ods !== "holy" &&
          element.ods !== "startDate" &&
          element.ods !== "endDate";

        if (tempODS) eventsProcessed.push(element);

        if (element.ods === "NA") eventsNA.push(element);
      }
      // console.log("EVENTS PROCESSED: ", eventsProcessed);
      // console.log("eventsNA: ", eventsNA);

      let lengthProcess = getters.realMonthTotalDays;
      for (let index = 1; index <= lengthProcess; index++) {
        let day = index;
        const monthPE =
          getters.currentMonthNumber < 10
            ? `0${getters.currentMonthNumber}`
            : `${getters.currentMonthNumber}`;
        if (day < 10) day = `0${index}`;
        const date = `${getters.currentYear}-${monthPE}-${day}`;
        const indexEvent = eventsProcessed.findIndex(
          item => item.date === date
        );
        const fullDate = new Date(`${date}, 00:00:00`);
        const weekday = fullDate.getDay();
        if (role === 0) {
          if (indexEvent === -1)
            eventsFinalProcess.push({
              date,
              ods: "X",
              nameDay: weekDaysMap.get(weekday)
            });
          else
            eventsFinalProcess.splice(
              indexEvent,
              0,
              eventsProcessed[indexEvent]
            );
        } else {
          const holyD = getters.holyDays;
          const index = holyD.findIndex(item => item.date === date);
          const isHolyDay = index !== -1;
          const indexNA = eventsNA.findIndex(item => item.date === date);
          const isNA = indexNA !== -1;
          if (!isHolyDay) {
            // const fullDate = new Date(`${date}, 00:00:00`);
            // const weekday = fullDate.getDay();
            if (weekday !== 0 && weekday !== 6) {
              if (indexEvent === -1)
                eventsFinalProcess.push({
                  date,
                  ods: "X",
                  nameDay: weekDaysMap.get(weekday)
                });
              else
                eventsFinalProcess.splice(
                  indexEvent,
                  0,
                  eventsProcessed[indexEvent]
                );
            } else {
              eventsFinalProcess.push({
                date,
                ods: isNA ? "NA" : 5,
                odsN: isNA ? "NA" : "D",
                nameDay: weekDaysMap.get(weekday)
              });
            }
          } else {
            eventsFinalProcess.push({
              date,
              ods: isNA ? "NA" : 5,
              odsN: isNA ? "NA" : "D",
              nameDay: weekDaysMap.get(weekday)
            });
          }
        }
      }
      const eventsSort = eventsFinalProcess.sort(function(a, b) {
        var textA = a.date;
        var textB = b.date;
        return textA < textB ? -1 : textA > textB ? 1 : 0;
      });
      // console.log("EVENTS SORT: ", eventsSort);

      // console.log("EVENTS FINAL PROCESS: ", eventsFinalProcess);
      return eventsSort;
    },
    addComments({ commit }, data) {
      commit(SET_COMMENTS, data);
    },
    async sendODSRev({ commit, state, dispatch }, events) {
      commit(SET_LOADING, true);
      // console.log("EVENTS: ", events);
      const consecutive = await dispatch("consecutiveCalc");
      const eventsProccesed = await dispatch("processEvents", events);
      // console.log("POST PROCESS", eventsProccesed);
      const amountX = eventsProccesed.filter(item => item.ods === "X").length;
      const amountXR = eventsProccesed.filter(item => item.odsN === "XR")
        .length;
      const amountC = eventsProccesed.filter(item => item.odsN === "C").length;
      const amountPL = eventsProccesed.filter(item => item.odsN === "PL")
        .length;
      const amountPNR = eventsProccesed.filter(item => item.odsN === "PNR")
        .length;
      const amountI = eventsProccesed.filter(item => item.odsN === "I").length;
      // if (getters.role === 0)
      const amountD = eventsProccesed.filter(item => item.odsN === "D").length;
      const total =
        amountX + amountXR + amountC + amountPL + amountPNR + amountI + amountD;

      const update = {
        consecutive,
        comments: state.comments,
        ods: state.userData.ods,
        user: state.userData.email,
        month: state.currentMonth,
        year: state.currentYear,
        dateSince: state.dateSince,
        dateUntil: state.dateUntil,
        amountOfWork: state.amountOfWork,
        events: eventsProccesed,
        amountX,
        amountXR,
        amountC,
        amountPL,
        amountPNR,
        amountI,
        amountD,
        total,
        approved: 0
      };
      return firebase
        .database()
        .ref(`ods/${state.currentUID}`)
        .update(update)
        .then(() => {
          // console.log("SEND ODS REV", response);
          commit(READ_ONLY_CALENDAR, true);
          // commit(SET_MESSAGE, "Enviado correctamente!");
          commit(SET_LOADING, false);
          commit(SET_APPROVED, 0);
          // const data = {
          //   uid,
          //   approved: 1
          // };
          // commit(SET_REVISION, data);
          commit(SET_COMMENTS, "");
          const payload = {
            showMessage: true,
            showCancelBtn: false,
            showSendBtn: false,
            showOkBtn: true,
            action: "",
            data: null,
            messageTitle: "Información Enviada",
            messageInfo: `La información correspondiente al mes de ${
              state.currentMonth
            } ha sido Reenviada correctamente para nueva revisión.`
          };
          commit(SET_GENERAL_MESSAGE, payload);
        })
        .catch(error => {
          commit(SET_LOADING, false);
          console.error("OK ODS ERROR", error);
        });
    },
    noAODS({ commit, state }, uid) {
      commit(SET_LOADING, true);
      // console.log("EVENTS: ", events);
      const update = {
        commentsLeader: state.comments,
        approved: 2,
        revision: true
      };
      return firebase
        .database()
        .ref(`ods/${uid}`)
        .update(update)
        .then(() => {
          // console.log("NOA ODS", response);
          // commit(READ_ONLY_CALENDAR, true);
          // commit(SET_MESSAGE, "No Aprobado correctamente!");
          commit(SET_LOADING, false);
          const data = {
            uid,
            approved: 2
          };
          commit(SET_REVISION, data);
          commit(SET_COMMENTS, "");
          const payload = {
            showMessage: true,
            showCancelBtn: false,
            showSendBtn: false,
            showOkBtn: true,
            action: "",
            data: null,
            messageTitle: "Información Enviada",
            messageInfo: "Se ha informado la No Aprobación del Service Ticket."
          };
          commit(SET_GENERAL_MESSAGE, payload);
        })
        .catch(error => {
          commit(SET_LOADING, false);
          console.log("NOA ODS ERROR", error);
        });
    },
    okODS({ commit }, payload) {
      commit(SET_LOADING, true);
      // console.log("EVENTS: ", events);
      const uid = payload.uid;
      const userUID = payload.userUID;
      const monthST = payload.month;
      const yearST = payload.year;

      const update = {
        approved: 1
      };
      return firebase
        .database()
        .ref(`ods/${uid}`)
        .update(update)
        .then(() => {
          // console.log("OK ODS", response);
          // commit(READ_ONLY_CALENDAR, true);
          // commit(SET_MESSAGE, "Aprobado correctamente!");
          const data = {
            uid: uid,
            approved: 1
          };
          commit(SET_REVISION, data);

          return firebase
            .database()
            .ref(`users/${userUID}`)
            .once("value");
        })
        .then(snapshot => {
          const userData = snapshot.val();
          // console.log("USER DATA", userData);
          const endDate = userData.endDate ? userData.endDate : null;

          let userReadyToDeactivate = false;
          if (endDate !== null) {
            const endDateSplit = endDate.split("/");
            const endDateMonthNumber = Number(endDateSplit[1]);
            const endDateYear = endDateSplit[2];
            const endDateMonth = monthsBaseInfo.get(endDateMonthNumber).name;
            if (endDateMonth === monthST && endDateYear === yearST)
              userReadyToDeactivate = true;
          }

          if (userReadyToDeactivate) {
            const update = {
              readyToDeactivate: true
            };
            return firebase
              .database()
              .ref(`users/${userUID}`)
              .update(update);
          } else return true;
        })
        .then(() => {
          // console.log("FINISHED", response);
          commit(SET_LOADING, false);

          const payload = {
            showMessage: true,
            showCancelBtn: false,
            showSendBtn: false,
            showOkBtn: true,
            action: "",
            data: null,
            messageTitle: "Información Enviada",
            messageInfo: "Se ha informado la Aprobación del Service Ticket."
          };
          commit(SET_GENERAL_MESSAGE, payload);
        })
        .catch(error => {
          commit(SET_LOADING, false);
          console.error("OK ODS ERROR", error);
        });
    },
    fetchODSInfo({ commit, state }, ods) {
      // console.log("FETCH ODS INFO: ", ods);
      commit(SET_LOADING, true);
      firebase
        .database()
        .ref("ods")
        .orderByChild("month")
        .equalTo(state.currentMonth)
        .once("value")
        .then(snapshot => {
          const obj = snapshot.val();
          // console.log("FETCH ODS INFO", obj);
          let data = [];
          for (let key in obj) {
            const endDateEventCheck = obj[key].endDateEvent
              ? obj[key].endDateEvent
              : [];
            const dataIn = {
              year: obj[key].year,
              userUID: obj[key].userUID,
              uid: key,
              ods: obj[key].ods,
              user: obj[key].user,
              month: obj[key].month,
              events: [
                ...obj[key].startDateEvent,
                ...endDateEventCheck,
                ...obj[key].events
              ],
              revised: obj[key].revised,
              approved: obj[key].approved,
              comments: obj[key].comments,
              emailLF: obj[key].emailLF,
              emailAODS: obj[key].emailAODS
            };
            data.push(dataIn);
          }
          // console.log("DATA: ", data);

          // Filter by the selected ODS
          const dataOdsFiletered = data.filter(item => item.ods === ods);
          // console.log("dataOdsFiletered: ", dataOdsFiletered);

          // Filter ST in relation with the current user in session
          let finalSTFiltered = [];
          if (state.userData.role === 2) {
            finalSTFiltered = dataOdsFiletered.filter(
              item => item.emailLF === state.userData.email
            );
          } else if (state.userData.role === 3) {
            finalSTFiltered = dataOdsFiletered.filter(
              item => item.emailAODS === state.userData.email
            );
          }

          const yearFilteredST = finalSTFiltered.filter(
            item => item.year === state.currentYear
          );
          // commit(SET_LOADED_ODS, data);
          // commit(SET_LOADED_ODS, dataOdsFiletered);
          commit(SET_LOADED_ODS, yearFilteredST);
          // commit(SET_LOADING, false);

          return firebase
            .database()
            .ref("ods")
            .orderByChild("month")
            .equalTo(state.currentRealMonth)
            .once("value");
        })
        .then(snapshot => {
          const obj = snapshot.val();
          // console.log("FETCH ODS INFO", obj);
          let data = [];
          for (let key in obj) {
            const endDateEventCheck = obj[key].endDateEvent
              ? obj[key].endDateEvent
              : [];
            const dataIn = {
              year: obj[key].year,
              userUID: obj[key].userUID,
              uid: key,
              ods: obj[key].ods,
              user: obj[key].user,
              month: obj[key].month,
              events: [
                ...obj[key].startDateEvent,
                ...endDateEventCheck,
                ...obj[key].events
              ],
              revised: obj[key].revised,
              approved: obj[key].approved,
              comments: obj[key].comments,
              emailLF: obj[key].emailLF,
              emailAODS: obj[key].emailAODS
            };
            data.push(dataIn);
          }
          // console.log("DATA: ", data);

          // Filter by the selected ODS
          const dataOdsFiletered = data.filter(item => item.ods === ods);
          // console.log("dataOdsFiletered: ", dataOdsFiletered);

          // Filter ST in relation with the current user in session
          let finalSTFiltered = [];
          if (state.userData.role === 2) {
            finalSTFiltered = dataOdsFiletered.filter(
              item => item.emailLF === state.userData.email
            );
          } else if (state.userData.role === 3) {
            finalSTFiltered = dataOdsFiletered.filter(
              item => item.emailAODS === state.userData.email
            );
          }
          const yearFilteredST = finalSTFiltered.filter(
            item =>
              item.year === state.currentYear || item.year === state.yearFooter
          );
          commit(SET_LOADED_ODS_CURRENT_REAL_MONTH, yearFilteredST);
          commit(SET_LOADING, false);
        })
        .catch(error => {
          commit(SET_LOADING, false);
          console.log("ERROR FODSI", error);
        });
    },
    showGeneralMessage({ commit }, payload) {
      commit(SET_GENERAL_MESSAGE, payload);
    },
    fetchEvents({ commit, state }) {
      commit(SET_LOADING, true);
      return firebase
        .database()
        .ref("ods")
        .orderByChild("user")
        .equalTo(state.userData.email)
        .once("value")
        .then(
          function(snapshot) {
            const obj = snapshot.val();
            // console.log("FETCH EVENTS DATA", obj);
            let events = [];
            let approved = null;
            let uid = "";
            let commentsLeader = "";
            for (let key in obj) {
              // console.log("OBJ: ", obj[key].month);
              if (
                obj[key].month === state.currentMonth &&
                obj[key].year === state.currentYear
              ) {
                uid = key;
                events = obj[key].events;
                approved = obj[key].approved;
                commentsLeader = obj[key].commentsLeader;
                // console.log("UID TRUE: ", uid);
              }
            }
            const filterEventsNA = events.filter(item => item.ods !== "NA");
            commit(EVENTS_FROM_DB, filterEventsNA);
            commit(SET_APPROVED, approved);
            commit(SET_CURRENT_UID, uid);
            commit(SET_COMMENTS_LEADER, commentsLeader);
            if (events.length > 0) {
              commit(READ_ONLY_CALENDAR, true);
              // commit(SET_MESSAGE, "Informe cargado correctamente!");
              const payload = {
                showMessage: true,
                showCancelBtn: false,
                showSendBtn: false,
                showOkBtn: true,
                action: "",
                data: null,
                messageTitle: "Información Cargada",
                messageInfo: `La información correspondiente al mes de ${
                  state.currentMonth
                } ha sido cargada correctamente.`
              };
              commit(SET_GENERAL_MESSAGE, payload);
            }
            commit(SET_LOADING, false);
          },
          function(errorObject) {
            commit(SET_LOADING, false);
            console.log(errorObject);
          }
        );
    },
    async sendODS({ commit, state, dispatch }, events) {
      commit(SET_LOADING, true);
      // console.log("EVENTS: ", events);
      const consecutive = await dispatch("consecutiveCalc");
      const eventsProccesed = await dispatch("processEvents", events);
      // console.log("POST PROCESS", eventsProccesed);
      const amountX = eventsProccesed.filter(item => item.ods === "X").length;
      const amountXR = eventsProccesed.filter(item => item.odsN === "XR")
        .length;
      const amountC = eventsProccesed.filter(item => item.odsN === "C").length;
      const amountPL = eventsProccesed.filter(item => item.odsN === "PL")
        .length;
      const amountPNR = eventsProccesed.filter(item => item.odsN === "PNR")
        .length;
      const amountI = eventsProccesed.filter(item => item.odsN === "I").length;
      // if (getters.role === 0)
      const amountD = eventsProccesed.filter(item => item.odsN === "D").length;
      const total =
        amountX + amountXR + amountC + amountPL + amountPNR + amountI + amountD;

      return firebase
        .database()
        .ref("ods/")
        .push({
          startDateEvent: state.startDateEvent,
          endDateEvent: state.endDateEvent,
          userUID: state.userData.userUID,
          consecutive,
          role: state.userData.role,
          comments: state.comments,
          ods: state.userData.ods,
          user: state.userData.email,
          month: state.currentMonth,
          year: state.currentYear,
          dateSince: state.dateSince,
          dateUntil: state.dateUntil,
          amountOfWork: state.amountOfWork,
          events: eventsProccesed,
          amountX,
          amountXR,
          amountC,
          amountPL,
          amountPNR,
          amountI,
          amountD,
          total,
          // revised: false,
          approved: 0,
          emailLF: state.userData.emailLF,
          emailAODS: state.userData.emailAODS
        })
        .then(() => {
          // console.log("SEND ODS", response);
          commit(READ_ONLY_CALENDAR, true);
          commit(SET_APPROVED, 0);
          // commit(SET_MESSAGE, "Informe enviado correctamente!");
          commit(SET_LOADING, false);
          commit(SET_COMMENTS, "");
          const payload = {
            showMessage: true,
            showCancelBtn: false,
            showSendBtn: false,
            showOkBtn: true,
            action: "",
            data: null,
            messageTitle: "Información Enviada",
            messageInfo:
              "La información del Service Ticket ha sido Enviada correctamente."
          };
          commit(SET_GENERAL_MESSAGE, payload);
          dispatch("fetchEvents");
        })
        .catch(error => {
          commit(SET_LOADING, false);
          console.log("SEND ODS ERROR", error);
        });
    },
    logout({ commit }) {
      // console.log("SINGOUT GETTER");
      firebase.auth().signOut();
      const data = {
        user: "",
        password: ""
      };
      commit(LOGIN_DATA, data);
      commit(INIT_VALUES);
      commit(IS_LOGGED_IN, false);
    },
    loginData({ commit }, data) {
      commit(LOGIN_DATA, data);
    },
    signin({ commit, state }) {
      // console.log("SIGNIN ->");
      commit(SET_LOADING, true);
      firebase
        .auth()
        .signInWithEmailAndPassword(state.user, state.password)
        .catch(function(error) {
          // Handle Errors here.
          commit(SET_LOADING, false);
          const errorCode = error.code;
          // console.log("ERROR CODE", errorCode);
          let message =
            "No se ha podido Iniciar Sesión. Por favor intentar de nuevo.";
          if (
            errorCode === "auth/invalid-email" ||
            errorCode === "auth/wrong-password"
          )
            message = "Los datos enviados no son validos para Iniciar Sesión";
          else if (errorCode === "auth/user-disabled")
            message =
              "Usuario acutalmente desactivado. Si considera que su usuario debe estar activo por favor contactar al administrador de la plataforma.";

          const payload = {
            showMessage: true,
            showCancelBtn: false,
            showSendBtn: false,
            showOkBtn: true,
            action: "",
            data: null,
            messageTitle: "ERROR",
            messageInfo: message
          };
          commit(SET_GENERAL_MESSAGE, payload);
          const errorMessage = error.message;
          console.log("ERROR MESSAGE", errorMessage);
          // ...
        });
      // console.log("LOGIN OK");
    },
    changeLoginState({ commit }, value) {
      commit(IS_LOGGED_IN, value);
    },
    userData({ commit }, data) {
      // console.log("DATA: ", data.uid);
      commit(SET_LOADING, true);
      return firebase
        .database()
        .ref("users/" + data.uid)
        .once("value")
        .then(
          function(snapshot) {
            const obj = snapshot.val();
            // console.log("OBJ", obj);
            // console.log("THEN DATA USER DATA", obj.ods);
            const role = obj.role;
            let ods;
            if (role > 1) {
              ods = [];
              for (let key in obj.ods) {
                ods.push(key);
              }
            } else ods = obj.ods;
            const infoUser = {
              email: data.email,
              uid: data.uid,
              firstName: obj.firstName,
              lastName: obj.lastName,
              role,
              ods,
              emailLF: obj.emailLF,
              emailAODS: obj.emailAODS,
              startDate: obj.startDate
            };
            if (obj.endDate) infoUser.endDate = obj.endDate;
            if (infoUser.role > 1) router.push("/ods");
            commit(USER_DATA, infoUser);
            // dispatch("fetchEvents");
            // commit(SET_LOADING, false);
          },
          function(errorObject) {
            console.log(errorObject);
          }
        );
    },
    changeAuth({ commit }, data) {
      commit(CHANGE_AUTH, data);
    },
    fetchUsers({ commit }) {
      firebase
        .database()
        .ref(`users/`)
        .on("value", function(snapshot) {
          const obj = snapshot.val();
          const users = [];
          for (let key in obj) {
            const role = obj[key].role;
            let ods;
            if (role > 1) {
              ods = [];
              for (let key1 in obj[key].ods) {
                ods.push(key1);
              }
            } else ods = obj[key].ods;
            users.push({
              active: obj[key].active,
              uid: key,
              email: obj[key].email,
              firstName: obj[key].firstName,
              lastName: obj[key].lastName,
              role,
              ods,
              startDate: obj[key].startDate ? obj[key].startDate : null,
              endDate: obj[key].endDate ? obj[key].endDate : null,
              readyToDeactivate: obj[key].readyToDeactivate
                ? obj[key].readyToDeactivate
                : null
            });
          }
          // console.log(`USERS  --> ${users}`);
          commit(FETCH_USERS, users);
        });
    },
    setNewUserData({ commit }, data) {
      commit(SET_NEW_USER_DATA, data);
    },
    createUser({ commit, state }, data) {
      commit(SET_DISABLE_ALL, true);
      let ods = null;
      if (state.userDataCRUD.role > 1) {
        ods = {};
        state.userDataCRUD.ods.forEach(element => {
          ods[element] = true;
        });
      } else ods = state.userDataCRUD.ods;
      // const newData = {
      //   email: state.userDataCRUD.email,
      //   firstName: state.userDataCRUD.firstName,
      //   lastName: state.userDataCRUD.lastName,
      //   role: state.userDataCRUD.role,
      //   ods
      // };
      // let fullNewData = [];
      // fullNewData = [...newData, ...data];
      data.email = state.userDataCRUD.email;
      data.role = state.userDataCRUD.role;
      data.ods = ods;

      // console.log("FULL NEW DATA: ", fullNewData);
      console.log("FULL NEW DATA: ", data);
      axios
        .post(
          `https://us-central1-${projectId}.cloudfunctions.net/newUserAPI`,
          {
            userData: data
          }
        )
        .then(response => {
          // console.log("RESPONSE! -> ", response);
          // console.log("SUCCESS? -> ", response.data.success);
          if (response.data.success) {
            console.log("USER CREATED!");
          } else {
            console.log("USER NOT CREATED!");
          }
          commit(SET_DISABLE_ALL, false);
        })
        .catch(error => {
          console.log("ERROR! -> ", error);
          commit(SET_DISABLE_ALL, false);
        });
    }
  }
});
